<template>
  <ul class="toggle-multi-choice toggle_wrap">
    <li v-for="(item, index) in list" :key="index">
      <a class="toggle" :class="`${whichButtonIsActive(index)}`" @click="updateActiveButton(index)">
        <svg class="toggle-multi-choice_svg">
          <use :xlink:href="item.svg"></use>
        </svg>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    list: Array,
    active: Number
  },
  data() {
    return {
      ActiveItem: this.active,
      lengthObj: ""
    };
  },
  methods: {
    // fetch which button is active
    whichButtonIsActive(index) {
      if (index === this.ActiveItem) {
        return "active";
      }
      return;
    },
    // User click on a button
    updateActiveButton(index) {
      // check if its already active
      if (index === this.ActiveItem) {
        return;
      }
      // update the Object list
      this.ActiveItem = index;
      // Emit the object list to the parent div
      this.$emit("event_parent", this.ActiveItem);
    }
  }
};
</script>